import React, { useEffect } from "react";
import { useAppContext } from "../context";
import backgroundMusic from '/sounds/bg.mp3';

const backgroundAudio = new Audio(backgroundMusic);
backgroundAudio.loop = true;

const BG_VOLUME_DEFAULT = 1;
const BG_VOLUME_CHAT = 0.5;

export const SoundProvider = (props: { children: React.ReactNode }) => {
    const { musicPlay, currentRoute } = useAppContext();

    useEffect(() => {
        backgroundAudio.volume =
            currentRoute === "chat" ? BG_VOLUME_CHAT : BG_VOLUME_DEFAULT;
    }, [currentRoute]);

    useEffect(() => {
        if (musicPlay) {
            if (backgroundAudio.paused) {
                backgroundAudio.play();
            }
        } else {
            backgroundAudio.pause();
        }

    }, [musicPlay]);

    return props.children;
}